import React from 'react';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';
import { AbstractWelcomePage, _mapStateToProps } from "./AbstractWelcomePage";
class NewFeaturesPopup extends AbstractWelcomePage {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state
        };
        this._onToggleButtonClick = this._onToggleButtonClick.bind(this);
    }
    /**
     * Handler for the toggle button.
     *
     * @param {Object} e - The synthetic event.
     * @returns {void}
     */
    _onToggleButtonClick() {
        var showNews = localStorage.getItem("showAgainNewsJune2025");
        if (showNews != null && showNews == 'false') {
            localStorage.setItem("showAgainNewsJune2025", 'true');
        }
        else {
            localStorage.setItem("showAgainNewsJune2025", 'false');
        }
    }
    render() {
        var nome = "";
        let us = localStorage.getItem("user");
        if (us != null) {
            var user = JSON.parse(us?.toString());
            if (user.result == 1) {
                nome = user.name + ',';
            }
        }
        let classButton = "";
        let displayNews = "";
        if (window.location.href.includes('kalliope')) {
            classButton = 'buttonKA';
            displayNews = 'none';
        }
        else if (window.location.href.includes('vianova')) {
            classButton = 'buttonWI';
            displayNews = 'flex';
        }
        return (React.createElement("div", { className: 'modal' },
            React.createElement("div", { className: 'modal-content' },
                React.createElement("span", { className: "close", onClick: this.props.closePopup }, " \u00D7 "),
                React.createElement("h1", { className: "titleNewFeatures" },
                    " ",
                    this.props.t('NewFeaturesPopup.title'),
                    " "),
                React.createElement("small", { className: "release" },
                    " ",
                    this.props.t('NewFeaturesPopup.release'),
                    " "),
                React.createElement("h4", { className: "testoPopupnewFeatures" },
                    this.props.t('NewFeaturesPopup.greeting'),
                    nome,
                    React.createElement("br", null),
                    this.props.t('NewFeaturesPopup.body')),
                React.createElement("div", { style: { display: displayNews, justifyContent: 'center', marginBottom: '25px' } },
                    React.createElement("small", { className: "news" },
                        " ",
                        this.props.t('NewFeaturesPopup.link1')),
                    " ",
                    React.createElement("a", { className: "showNewFeatures", target: "_black", href: this.props.t('NewFeaturesPopup.link2') }, this.props.t('NewFeaturesPopup.link3'))),
                React.createElement("div", { className: "footerPopup" },
                    React.createElement("br", null),
                    React.createElement("button", { className: classButton, onClick: this.props.closePopup },
                        " ",
                        this.props.t('NewFeaturesPopup.ok'),
                        " "),
                    React.createElement("br", null),
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
                        React.createElement("input", { style: { width: '20px', height: '20px', marginRight: '8px' }, type: "checkbox", defaultChecked: this.state.chkbox, onChange: this._onToggleButtonClick }),
                        React.createElement("small", { className: "testoPopupnewFeatures" },
                            " ",
                            this.props.t('NewFeaturesPopup.doNotShow'),
                            " "))))));
    }
}
//export default LoginPopup;
export default translate(connect(_mapStateToProps)(NewFeaturesPopup));
